import { BaseService } from '@flint/framework';

export default class EPubFetchData extends BaseService {
  constructor() {
    super("FETCHING_EPUB_DATA", 'EPubStore', true);
  }

  handleEvent= eventName=>{
    return this.getClient('vetService').get("/admin-api/epubs/");
  }
}